import React, { useState } from "react";
import { Row, Col, Card, Button, Pagination, Form } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import BackArrow from "../../../components/backArrow";
import "./style.css";
const profiles = [
  { name: "Alex John", img: "https://randomuser.me/api/portraits/men/1.jpg" },
  {
    name: "Ammanda John",
    img: "https://randomuser.me/api/portraits/women/2.jpg",
  },
  {
    name: "Rossie Feat",
    img: "https://randomuser.me/api/portraits/women/3.jpg",
  },

  { name: "John kel", img: "https://randomuser.me/api/portraits/men/4.jpg" },
  { name: "James Levin", img: "https://randomuser.me/api/portraits/men/5.jpg" },
];

const generateProfiles = (count) => {
  const list = [];
  for (let i = 0; i < count; i++) {
    list.push(profiles[i % profiles.length]);
  }
  return list;
};

const ConnectedProfiles = () => {
  const allProfiles = generateProfiles(105);
  const [currentPage, setCurrentPage] = useState(1);
  const profilesPerPage = 20;

  const indexOfLast = currentPage * profilesPerPage;
  const indexOfFirst = indexOfLast - profilesPerPage;
  const currentProfiles = allProfiles.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(allProfiles.length / profilesPerPage);
  const [activeTab, setActiveTab] = useState("my-connections");

  return (
    <Col xl="8" lg="10" md="12" xs="12" sm="12" className="py-4 px-3 m-auto">
      <div className="screenHeight">
        {/* Top Header */}
        <BackArrow />
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center gap-3">
            <div className="connected-mobile">
              <h5 className="mb-0 text-primary fw-bold">Connected profiles</h5>
              <small className="text-muted">105 Connected</small>
            </div>
          </div>

          <div className="d-flex gap-4 connected-tab">
            <div
              role="button"
              className={`pb-2 tab-link ${
                activeTab === "random" ? "active-tab" : ""
              }`}
              onClick={() => setActiveTab("random")}
            >
              Random People’s
            </div>
            <div
              role="button"
              className={`pb-2 tab-link ${
                activeTab === "my-connections" ? "active-tab" : ""
              }`}
              onClick={() => setActiveTab("my-connections")}
            >
              My connections
            </div>
          </div>

          <div className="position-relative">
            <FaSearch
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#999",
                fontSize: "0.85rem",
              }}
            />
            <Form.Control
              type="text"
              placeholder="Search"
              style={{
                paddingLeft: "30px",
                borderRadius: "8px",
                borderColor: "#ddd",
                fontSize: "0.9rem",
              }}
            />
          </div>
        </div>

        {/* Tabs */}

        {/* Profile Cards Grid */}
        <Row>
          {currentProfiles.map((profile, idx) => (
            <Col key={idx} xs={6} sm={4} md={3} lg={2} className="mb-4">
              <Card className="text-center shadow-sm">
                <Card.Img
                  variant="top"
                  src={profile.img}
                  className="rounded-circle mx-auto mt-3"
                  style={{ width: "70px", height: "70px", objectFit: "cover" }}
                />
                <Card.Body className="p-2">
                  <Card.Title className="font_13 mb-2">
                    {profile.name}
                  </Card.Title>
                  <Button
                    variant="outline-primary rounded-pill pt-0 pb-0 connected-p-b"
                    style={{ fontSize: "10px", color: "#007bff" }}
                  >
                    connect
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Pagination */}
        <Pagination className="justify-content-center">
          <Pagination.First
            onClick={() => setCurrentPage(1)}
            disabled={currentPage === 1}
          />
          {[...Array(Math.min(totalPages, 5)).keys()].map((number) => (
            <Pagination.Item
              key={number + 1}
              active={number + 1 === currentPage}
              onClick={() => setCurrentPage(number + 1)}
            >
              {number + 1}
            </Pagination.Item>
          ))}

          {totalPages > 5 && (
            <>
              <Pagination.Ellipsis disabled />
              <Pagination.Item onClick={() => setCurrentPage(totalPages)}>
                {totalPages}
              </Pagination.Item>
            </>
          )}
          <Pagination.Last
            onClick={() => setCurrentPage(totalPages)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
    </Col>
  );
};

export default ConnectedProfiles;
